import React from "react"
import PropTypes from "prop-types"

import styles from "./pageSection.module.scss"

const PageSection = (props) => {
  const {
    backgroundColor,
    children,
    rootStyles,
    centerVertical,
    centerHorizontal,
    collapseAt,
    RightComponent,
    LeftComponent
  } = props;

  let baseStyles = [styles.root]
  if (rootStyles) {
    baseStyles = baseStyles.concat(rootStyles)
  }

  let childClasses = [styles.paddingContainer]
  if (centerVertical) {
    childClasses = childClasses.concat(styles.centerVertical)
  }
  if (centerHorizontal) {
    childClasses = childClasses.concat(styles.centerHorizontal)
  }

  let contentClasses = [styles.contentContainer]
  if (collapseAt === 'large') {
    contentClasses = contentClasses.concat(styles.collapseLarge)
  }
  if (collapseAt === 'small') {
    contentClasses = contentClasses.concat(styles.collapseSmall)
  }

  return (
    <section style={{ backgroundColor }} className={baseStyles.join(" ")}>
      <div className={contentClasses.join(" ")}>
        {LeftComponent && <LeftComponent />}
        <div className={childClasses.join(" ")}>
          {children}
        </div>
        {RightComponent && <RightComponent />}
      </div>
    </section>
  )
}

PageSection.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

PageSection.defaultProps = {
  backgroundColor: 'white',
  centerVertical: false,
  centerHorizontal: false,
}

export default PageSection
